import { render, staticRenderFns } from "./expandable-list.vue?vue&type=template&id=5f0e8d8e&scoped=true"
import script from "./expandable-list.vue?vue&type=script&lang=js"
export * from "./expandable-list.vue?vue&type=script&lang=js"
import style0 from "./expandable-list.vue?vue&type=style&index=0&id=5f0e8d8e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e8d8e",
  null
  
)

export default component.exports